// ============================================================
// Dışa aktarma arayüzü (§11)
// ============================================================

import { card, sectionTitle } from "./ui.js";
import { esc } from "../lib/fmt.js";
import { AKTARIMLAR, aktarimUret } from "../domain/export.js";
import { yapabilir } from "../domain/auth.js";

/** Tarayıcıdan dosya indirir. */
export function dosyaIndir(dosya) {
  const blob = new Blob([dosya.icerik], { type: dosya.tur });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = dosya.dosyaAdi;
  a.click();
  URL.revokeObjectURL(url);
}

/** Ayarlar'daki dışa aktarma kartı. */
export function aktarimKarti() {
  const izinli = Object.entries(AKTARIMLAR).filter(([, t]) => yapabilir(t.yetki));

  return card(`
    <div class="p-5">
      ${sectionTitle("Dışa Aktarma", `<span class="text-[11px] text-inksoft hidden sm:block">CSV — her muhasebe programı açar</span>`)}
      <p class="text-[11px] text-inksoft mb-3">
        Aktarılan dosya kurumun sorumluluğundan çıkıp kişinin bilgisayarına
        iner. Her aktarım denetim izine yazılır.
      </p>

      <div class="grid gap-2 sm:grid-cols-2">
        ${izinli.map(([kod, t]) => `
          <button data-aktarim="${kod}"
            class="text-left rounded-xl border border-line px-3 py-2.5 hover:bg-paper transition">
            <span class="block text-sm font-semibold">${esc(t.label)}</span>
            <span class="block text-[11px] text-inksoft">${esc(t.aciklama)}</span>
          </button>`).join("")}
      </div>

      ${izinli.length < Object.keys(AKTARIMLAR).length ? `
        <p class="text-[11px] text-inksoft mt-3">
          Bazı aktarımlar rolünüze kapalı — mali dökümler yalnızca yönetimdedir.
        </p>` : ""}
    </div>`, "min-w-0");
}

export { aktarimUret };
